/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TripsRouteImport } from './routes/trips'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as ExampleRouteImport } from './routes/example'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TripPlanRouteImport } from './routes/trip/plan'
import { Route as TripPaymentRouteImport } from './routes/trip/payment'
import { Route as LegalTermsRouteImport } from './routes/legal/terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal/privacy'
import { Route as LegalCookiesRouteImport } from './routes/legal/cookies'
import { Route as AffiliateSignupRouteImport } from './routes/affiliate/signup'
import { Route as AffiliateDashboardRouteImport } from './routes/affiliate/dashboard'
import { Route as AdminDestinationsRouteImport } from './routes/admin/destinations'
import { Route as AdminAffiliatesRouteImport } from './routes/admin/affiliates'
import { Route as DestinationInterestRouteImport } from './routes/$destination.$interest'
import { Route as TripPlanIndexRouteImport } from './routes/trip/plan/index'
import { Route as TripTripIdTraditionalRouteImport } from './routes/trip/$tripId/traditional'
import { Route as TripTripIdStoryRouteImport } from './routes/trip/$tripId/story'
import { Route as TripTripIdMapRouteImport } from './routes/trip/$tripId/map'
import { Route as TripTripIdItineraryRouteImport } from './routes/trip/$tripId/itinerary'
import { Route as TripTripIdEditRouteImport } from './routes/trip/$tripId/edit'
import { Route as AdminDestinationsDestinationIdEditRouteImport } from './routes/admin/destinations/$destinationId/edit'

const TripsRoute = TripsRouteImport.update({
  id: '/trips',
  path: '/trips',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapRoute = SitemapRouteImport.update({
  id: '/sitemap',
  path: '/sitemap',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ExampleRoute = ExampleRouteImport.update({
  id: '/example',
  path: '/example',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TripPlanRoute = TripPlanRouteImport.update({
  id: '/trip/plan',
  path: '/trip/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const TripPaymentRoute = TripPaymentRouteImport.update({
  id: '/trip/payment',
  path: '/trip/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsRoute = LegalTermsRouteImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalCookiesRoute = LegalCookiesRouteImport.update({
  id: '/legal/cookies',
  path: '/legal/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliateSignupRoute = AffiliateSignupRouteImport.update({
  id: '/affiliate/signup',
  path: '/affiliate/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AffiliateDashboardRoute = AffiliateDashboardRouteImport.update({
  id: '/affiliate/dashboard',
  path: '/affiliate/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDestinationsRoute = AdminDestinationsRouteImport.update({
  id: '/admin/destinations',
  path: '/admin/destinations',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAffiliatesRoute = AdminAffiliatesRouteImport.update({
  id: '/admin/affiliates',
  path: '/admin/affiliates',
  getParentRoute: () => rootRouteImport,
} as any)
const DestinationInterestRoute = DestinationInterestRouteImport.update({
  id: '/$destination/$interest',
  path: '/$destination/$interest',
  getParentRoute: () => rootRouteImport,
} as any)
const TripPlanIndexRoute = TripPlanIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TripPlanRoute,
} as any)
const TripTripIdTraditionalRoute = TripTripIdTraditionalRouteImport.update({
  id: '/trip/$tripId/traditional',
  path: '/trip/$tripId/traditional',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdStoryRoute = TripTripIdStoryRouteImport.update({
  id: '/trip/$tripId/story',
  path: '/trip/$tripId/story',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdMapRoute = TripTripIdMapRouteImport.update({
  id: '/trip/$tripId/map',
  path: '/trip/$tripId/map',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdItineraryRoute = TripTripIdItineraryRouteImport.update({
  id: '/trip/$tripId/itinerary',
  path: '/trip/$tripId/itinerary',
  getParentRoute: () => rootRouteImport,
} as any)
const TripTripIdEditRoute = TripTripIdEditRouteImport.update({
  id: '/trip/$tripId/edit',
  path: '/trip/$tripId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDestinationsDestinationIdEditRoute =
  AdminDestinationsDestinationIdEditRouteImport.update({
    id: '/$destinationId/edit',
    path: '/$destinationId/edit',
    getParentRoute: () => AdminDestinationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/example': typeof ExampleRoute
  '/profile': typeof ProfileRoute
  '/sitemap': typeof SitemapRoute
  '/trips': typeof TripsRoute
  '/$destination/$interest': typeof DestinationInterestRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/destinations': typeof AdminDestinationsRouteWithChildren
  '/affiliate/dashboard': typeof AffiliateDashboardRoute
  '/affiliate/signup': typeof AffiliateSignupRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/trip/payment': typeof TripPaymentRoute
  '/trip/plan': typeof TripPlanRouteWithChildren
  '/trip/$tripId/edit': typeof TripTripIdEditRoute
  '/trip/$tripId/itinerary': typeof TripTripIdItineraryRoute
  '/trip/$tripId/map': typeof TripTripIdMapRoute
  '/trip/$tripId/story': typeof TripTripIdStoryRoute
  '/trip/$tripId/traditional': typeof TripTripIdTraditionalRoute
  '/trip/plan/': typeof TripPlanIndexRoute
  '/admin/destinations/$destinationId/edit': typeof AdminDestinationsDestinationIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/example': typeof ExampleRoute
  '/profile': typeof ProfileRoute
  '/sitemap': typeof SitemapRoute
  '/trips': typeof TripsRoute
  '/$destination/$interest': typeof DestinationInterestRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/destinations': typeof AdminDestinationsRouteWithChildren
  '/affiliate/dashboard': typeof AffiliateDashboardRoute
  '/affiliate/signup': typeof AffiliateSignupRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/trip/payment': typeof TripPaymentRoute
  '/trip/$tripId/edit': typeof TripTripIdEditRoute
  '/trip/$tripId/itinerary': typeof TripTripIdItineraryRoute
  '/trip/$tripId/map': typeof TripTripIdMapRoute
  '/trip/$tripId/story': typeof TripTripIdStoryRoute
  '/trip/$tripId/traditional': typeof TripTripIdTraditionalRoute
  '/trip/plan': typeof TripPlanIndexRoute
  '/admin/destinations/$destinationId/edit': typeof AdminDestinationsDestinationIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/example': typeof ExampleRoute
  '/profile': typeof ProfileRoute
  '/sitemap': typeof SitemapRoute
  '/trips': typeof TripsRoute
  '/$destination/$interest': typeof DestinationInterestRoute
  '/admin/affiliates': typeof AdminAffiliatesRoute
  '/admin/destinations': typeof AdminDestinationsRouteWithChildren
  '/affiliate/dashboard': typeof AffiliateDashboardRoute
  '/affiliate/signup': typeof AffiliateSignupRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/terms': typeof LegalTermsRoute
  '/trip/payment': typeof TripPaymentRoute
  '/trip/plan': typeof TripPlanRouteWithChildren
  '/trip/$tripId/edit': typeof TripTripIdEditRoute
  '/trip/$tripId/itinerary': typeof TripTripIdItineraryRoute
  '/trip/$tripId/map': typeof TripTripIdMapRoute
  '/trip/$tripId/story': typeof TripTripIdStoryRoute
  '/trip/$tripId/traditional': typeof TripTripIdTraditionalRoute
  '/trip/plan/': typeof TripPlanIndexRoute
  '/admin/destinations/$destinationId/edit': typeof AdminDestinationsDestinationIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/example'
    | '/profile'
    | '/sitemap'
    | '/trips'
    | '/$destination/$interest'
    | '/admin/affiliates'
    | '/admin/destinations'
    | '/affiliate/dashboard'
    | '/affiliate/signup'
    | '/legal/cookies'
    | '/legal/privacy'
    | '/legal/terms'
    | '/trip/payment'
    | '/trip/plan'
    | '/trip/$tripId/edit'
    | '/trip/$tripId/itinerary'
    | '/trip/$tripId/map'
    | '/trip/$tripId/story'
    | '/trip/$tripId/traditional'
    | '/trip/plan/'
    | '/admin/destinations/$destinationId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/example'
    | '/profile'
    | '/sitemap'
    | '/trips'
    | '/$destination/$interest'
    | '/admin/affiliates'
    | '/admin/destinations'
    | '/affiliate/dashboard'
    | '/affiliate/signup'
    | '/legal/cookies'
    | '/legal/privacy'
    | '/legal/terms'
    | '/trip/payment'
    | '/trip/$tripId/edit'
    | '/trip/$tripId/itinerary'
    | '/trip/$tripId/map'
    | '/trip/$tripId/story'
    | '/trip/$tripId/traditional'
    | '/trip/plan'
    | '/admin/destinations/$destinationId/edit'
  id:
    | '__root__'
    | '/'
    | '/example'
    | '/profile'
    | '/sitemap'
    | '/trips'
    | '/$destination/$interest'
    | '/admin/affiliates'
    | '/admin/destinations'
    | '/affiliate/dashboard'
    | '/affiliate/signup'
    | '/legal/cookies'
    | '/legal/privacy'
    | '/legal/terms'
    | '/trip/payment'
    | '/trip/plan'
    | '/trip/$tripId/edit'
    | '/trip/$tripId/itinerary'
    | '/trip/$tripId/map'
    | '/trip/$tripId/story'
    | '/trip/$tripId/traditional'
    | '/trip/plan/'
    | '/admin/destinations/$destinationId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ExampleRoute: typeof ExampleRoute
  ProfileRoute: typeof ProfileRoute
  SitemapRoute: typeof SitemapRoute
  TripsRoute: typeof TripsRoute
  DestinationInterestRoute: typeof DestinationInterestRoute
  AdminAffiliatesRoute: typeof AdminAffiliatesRoute
  AdminDestinationsRoute: typeof AdminDestinationsRouteWithChildren
  AffiliateDashboardRoute: typeof AffiliateDashboardRoute
  AffiliateSignupRoute: typeof AffiliateSignupRoute
  LegalCookiesRoute: typeof LegalCookiesRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalTermsRoute: typeof LegalTermsRoute
  TripPaymentRoute: typeof TripPaymentRoute
  TripPlanRoute: typeof TripPlanRouteWithChildren
  TripTripIdEditRoute: typeof TripTripIdEditRoute
  TripTripIdItineraryRoute: typeof TripTripIdItineraryRoute
  TripTripIdMapRoute: typeof TripTripIdMapRoute
  TripTripIdStoryRoute: typeof TripTripIdStoryRoute
  TripTripIdTraditionalRoute: typeof TripTripIdTraditionalRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trips': {
      id: '/trips'
      path: '/trips'
      fullPath: '/trips'
      preLoaderRoute: typeof TripsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap': {
      id: '/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof SitemapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/example': {
      id: '/example'
      path: '/example'
      fullPath: '/example'
      preLoaderRoute: typeof ExampleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/plan': {
      id: '/trip/plan'
      path: '/trip/plan'
      fullPath: '/trip/plan'
      preLoaderRoute: typeof TripPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/payment': {
      id: '/trip/payment'
      path: '/trip/payment'
      fullPath: '/trip/payment'
      preLoaderRoute: typeof TripPaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/cookies': {
      id: '/legal/cookies'
      path: '/legal/cookies'
      fullPath: '/legal/cookies'
      preLoaderRoute: typeof LegalCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliate/signup': {
      id: '/affiliate/signup'
      path: '/affiliate/signup'
      fullPath: '/affiliate/signup'
      preLoaderRoute: typeof AffiliateSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/affiliate/dashboard': {
      id: '/affiliate/dashboard'
      path: '/affiliate/dashboard'
      fullPath: '/affiliate/dashboard'
      preLoaderRoute: typeof AffiliateDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/destinations': {
      id: '/admin/destinations'
      path: '/admin/destinations'
      fullPath: '/admin/destinations'
      preLoaderRoute: typeof AdminDestinationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/affiliates': {
      id: '/admin/affiliates'
      path: '/admin/affiliates'
      fullPath: '/admin/affiliates'
      preLoaderRoute: typeof AdminAffiliatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$destination/$interest': {
      id: '/$destination/$interest'
      path: '/$destination/$interest'
      fullPath: '/$destination/$interest'
      preLoaderRoute: typeof DestinationInterestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/plan/': {
      id: '/trip/plan/'
      path: '/'
      fullPath: '/trip/plan/'
      preLoaderRoute: typeof TripPlanIndexRouteImport
      parentRoute: typeof TripPlanRoute
    }
    '/trip/$tripId/traditional': {
      id: '/trip/$tripId/traditional'
      path: '/trip/$tripId/traditional'
      fullPath: '/trip/$tripId/traditional'
      preLoaderRoute: typeof TripTripIdTraditionalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId/story': {
      id: '/trip/$tripId/story'
      path: '/trip/$tripId/story'
      fullPath: '/trip/$tripId/story'
      preLoaderRoute: typeof TripTripIdStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId/map': {
      id: '/trip/$tripId/map'
      path: '/trip/$tripId/map'
      fullPath: '/trip/$tripId/map'
      preLoaderRoute: typeof TripTripIdMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId/itinerary': {
      id: '/trip/$tripId/itinerary'
      path: '/trip/$tripId/itinerary'
      fullPath: '/trip/$tripId/itinerary'
      preLoaderRoute: typeof TripTripIdItineraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trip/$tripId/edit': {
      id: '/trip/$tripId/edit'
      path: '/trip/$tripId/edit'
      fullPath: '/trip/$tripId/edit'
      preLoaderRoute: typeof TripTripIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/destinations/$destinationId/edit': {
      id: '/admin/destinations/$destinationId/edit'
      path: '/$destinationId/edit'
      fullPath: '/admin/destinations/$destinationId/edit'
      preLoaderRoute: typeof AdminDestinationsDestinationIdEditRouteImport
      parentRoute: typeof AdminDestinationsRoute
    }
  }
}

interface AdminDestinationsRouteChildren {
  AdminDestinationsDestinationIdEditRoute: typeof AdminDestinationsDestinationIdEditRoute
}

const AdminDestinationsRouteChildren: AdminDestinationsRouteChildren = {
  AdminDestinationsDestinationIdEditRoute:
    AdminDestinationsDestinationIdEditRoute,
}

const AdminDestinationsRouteWithChildren =
  AdminDestinationsRoute._addFileChildren(AdminDestinationsRouteChildren)

interface TripPlanRouteChildren {
  TripPlanIndexRoute: typeof TripPlanIndexRoute
}

const TripPlanRouteChildren: TripPlanRouteChildren = {
  TripPlanIndexRoute: TripPlanIndexRoute,
}

const TripPlanRouteWithChildren = TripPlanRoute._addFileChildren(
  TripPlanRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ExampleRoute: ExampleRoute,
  ProfileRoute: ProfileRoute,
  SitemapRoute: SitemapRoute,
  TripsRoute: TripsRoute,
  DestinationInterestRoute: DestinationInterestRoute,
  AdminAffiliatesRoute: AdminAffiliatesRoute,
  AdminDestinationsRoute: AdminDestinationsRouteWithChildren,
  AffiliateDashboardRoute: AffiliateDashboardRoute,
  AffiliateSignupRoute: AffiliateSignupRoute,
  LegalCookiesRoute: LegalCookiesRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalTermsRoute: LegalTermsRoute,
  TripPaymentRoute: TripPaymentRoute,
  TripPlanRoute: TripPlanRouteWithChildren,
  TripTripIdEditRoute: TripTripIdEditRoute,
  TripTripIdItineraryRoute: TripTripIdItineraryRoute,
  TripTripIdMapRoute: TripTripIdMapRoute,
  TripTripIdStoryRoute: TripTripIdStoryRoute,
  TripTripIdTraditionalRoute: TripTripIdTraditionalRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
